import useRoles from "@/hooks/useRoles";
import { useAddAlert } from "@/hooks/useAddAlert";
import { selectProfile } from "@store/profile.reducer";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import useTeacherCanInitiateChat from "@/hooks/useTeacherCanInitiateChat";
import { openPrivateChat as openPrivateChatHelper } from "@common/Chat/helpers/openPrivateChat";

const useOpenPrivateChatFromGroupChat = ({ isGroupChat, targetUserId, setPage }) => {
    const addAlert = useAddAlert();
    const profile = useSelector(selectProfile);
    const { isChildrenOrParent, isEmployee, isSeminarian } = useRoles();
    const teacherCanInitiateChat = useTeacherCanInitiateChat();
    const isTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore = useSelector(
        (store) => store.settings.isTeachersCanWritePrivatelyToAnyMemberOfGroupChat
    );
    const isEmployeesExceptTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore = useSelector(
        (store) => store.settings.isEmployeesExceptTeachersCanWritePrivatelyToAnyMemberOfGroupChat
    );
    const isChildrenAndParentCanWritePrivatelyToAnyMemberOfGroupChatStore = useSelector(
        (store) => store.settings.isChildrenAndParentCanWritePrivatelyToAnyMemberOfGroupChat
    );

    const canOpenPrivateChat = useMemo(() => {
        const isTeacherRole = isSeminarian;
        const isEmployeeExceptTeacherRole = isEmployee && !isSeminarian;
        const isAnotherUser = Number(targetUserId) !== Number(profile?.id);

        return teacherCanInitiateChat && isAnotherUser && isGroupChat && (
            (isTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore === '1' && isTeacherRole) ||
            (isEmployeesExceptTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore === '1' && isEmployeeExceptTeacherRole) ||
            (isChildrenAndParentCanWritePrivatelyToAnyMemberOfGroupChatStore === '1' && isChildrenOrParent)
        );
    }, [
        isChildrenAndParentCanWritePrivatelyToAnyMemberOfGroupChatStore,
        isChildrenOrParent,
        isEmployee,
        isEmployeesExceptTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore,
        isGroupChat,
        isSeminarian,
        isTeachersCanWritePrivatelyToAnyMemberOfGroupChatStore,
        teacherCanInitiateChat,
        profile?.id,
        targetUserId
    ]);

    const openPrivateChat = useCallback((e) => {
        e?.stopPropagation?.();

        // Чат не создаём: открываем существующий или пустой диалог до первого сообщения
        openPrivateChatHelper({ userId: targetUserId, accessAlways: true, changePage: setPage })
            .catch((err) => addAlert({ text: err?.response?.data?.error || err?.message || err }))
    }, [addAlert, setPage, targetUserId]);

    return {
        canOpenPrivateChat,
        openPrivateChat,
    };
};

export default useOpenPrivateChatFromGroupChat;
